import { jsx as _jsx } from "react/jsx-runtime";
import LegalFormMultiSelect from '../multiselect/LegalFormMultiSelect';
export const FilterLegalFormMultiSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, showWithoutOption = false, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: (_jsx(LegalFormMultiSelect, { selection: activeFilters[item], onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }), placeholder: undefined, showWithoutOption: showWithoutOption })),
});
